import Header from "../../components/Header/Header";
import MentorFooter from "../../components/Footer/MentorFooter";
import { appendHomePageDataToUrl } from "../../utils/appendHomePageDataToUrl";
import BackToTop from "../../components/BackToTop/BackToTop";
import { useAppSelector } from "../../app/store";
import MentorContentFrame from "../../components/MentorBrowser/helpers/MentorContentFrame";
import MentorBrowser from "../../components/MentorBrowser/MentorBrowser";
import useMentorPalData from "../../components/MentorBrowser/helpers/useMentorPalData";
import type { SelectedMentorContent } from "../../components/MentorBrowser/helpers/types";
import styles from "./MentorPal.module.css";
import { useSearchParams } from "react-router-dom";
const MentorPal = ({
  completedPostSurvey,
  isResearchParticipant = true,
}: {
  completedPostSurvey: boolean;
  isResearchParticipant?: boolean;
}) => {
  const [searchParams] = useSearchParams();

  const { mentors, panels } = useMentorPalData();

  const { accessCode } = useAppSelector((state) => state.session);

  const mentorId = searchParams.get("mentorId");
  const panelId = searchParams.get("panelId");

  let selectedMentorContent: SelectedMentorContent | null = null;

  if (mentorId) {
    const mentor = mentors.find((m) => m._id === mentorId);
    if (mentor)
      selectedMentorContent = {
        url: appendHomePageDataToUrl([mentor._id], mentor.mentorUrl),
        title: mentor.name,
        mentors: [mentor],
      };
  }

  if (panelId) {
    const panel = panels.find((p) => p._id === panelId);

    if (panel) {
      const panelMentors = mentors.filter((mentor) =>
        panel.mentors.includes(mentor._id),
      );

      selectedMentorContent = {
        url: appendHomePageDataToUrl(
          panelMentors.map((mentor) => mentor._id),
          panel.panelUrl,
        ),
        title: panel.title,
        mentors: panelMentors,
      };
    }
  }

  return (
    <div className={styles.wrapper}>
      <Header />

      <main className={styles.mentorMain}>
        {selectedMentorContent ? (
          // When content is selected, only show the iframe
          <div className={styles.mentorContentWrapper}>
            <MentorContentFrame
              selected={selectedMentorContent}
              accessCode={accessCode ?? ""}
            />
          </div>
        ) : (
          // When no content is selected, show navigation and mentor sections
          <div>
            <section className={styles.mentorIntro}>
              <h2>Select a Mentor</h2>
              <p>Choose an individual mentor or a mentor panel.</p>
            </section>
            <div className={styles.mentorBrowserWrapper}>
              <MentorBrowser mentors={mentors} panels={panels} />
            </div>
          </div>
        )}
      </main>

      {isResearchParticipant ? (
        <MentorFooter
          selectedMentorContent={selectedMentorContent ?? undefined}
          enableTimer={!completedPostSurvey}
        />
      ) : (
        <MentorFooter
          selectedMentorContent={selectedMentorContent ?? undefined}
          enableTimer={false}
        />
      )}

      <BackToTop />
    </div>
  );
};

export default MentorPal;
